import {registerFormatType} from '@wordpress/rich-text';
import {JuZRichTextExtenderCustomButton} from "./components";

for (const format of juzRichTextExtender.formats) {
    if (format.tagName && format.tagName !== 'span') {
        console.warn(
            `[JuZ Rich Text Extender] CAUTION: format "${format.name}" uses tagName "${format.tagName}" instead of "span". ` +
            `This may cause invalid HTML nesting or conflicts with Gutenberg's internal formats (e.g. core/link). ` +
            `Using "span" with a:has(> .your-class) CSS is strongly recommended.`
        );
    }

    registerFormatType(`juz-rich-text-extender/${format.name}`, {
        title: format.title,
        tagName: format.tagName || 'span', // span by default
        className: format.className,
        edit: ({ isActive, onChange, value }) =>
            <JuZRichTextExtenderCustomButton {...{ isActive, onChange, value, format }} />,
    });
}